import { useSWRInfinite } from 'swr';
import { useCallback } from 'react';
import { fetcher } from 'utils/network/http';
import { useAuth } from 'hooks/useAuth/useAuth';

const usePaginationFetchData = (config) => {
  const { fetchFunc } = config;
  const { profile } = useAuth();

  const getData = useCallback(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.data.next) return null;

      if (pageIndex === 0) {
        return fetchFunc();
      }
      return previousPageData.data.next;
    },
    [fetchFunc]
  );

  const getPaginationVars = (response, error, size) => {
    const data =
      response && !error
        ? response.reduce((acc, item) => {
            return [...acc, ...item.data.results];
          }, [])
        : [];

    const isLoadingInitialData = !response && !error;
    const totalCount = isLoadingInitialData || response?.[0].data.count;
    const isEmpty = response?.[0]?.length === 0;
    console.log(
      'isLoadingInitial ',
      isLoadingInitialData,
      ' size ',
      size,
      ' response ',
      response
    );
    const isLoadingMore =
      isLoadingInitialData ||
      (size > 0 && response && typeof response[size - 1] === 'undefined');
    const hasMore = isEmpty ? false : data.length !== totalCount;
    return {
      isLoadingInitialData,
      isLoadingMore,
      hasMore,
      data,
    };
  };

  const { data: results, error, size, setSize } = useSWRInfinite(
    profile ? getData : null,
    fetcher,
    {
      revalidateAll: true,
    }
  );

  const {
    isLoadingInitialData,
    isLoadingMore,
    hasMore,
    data,
  } = getPaginationVars(results, error, size);

  return {
    isLoadingInitialData,
    error,
    isLoadingMore,
    hasMore,
    data,
    size,
    setSize,
  };
};

export default usePaginationFetchData;
